import { render, staticRenderFns } from "./Compo.vue?vue&type=template&id=2c34c346&scoped=true"
import script from "./Compo.vue?vue&type=script&lang=js"
export * from "./Compo.vue?vue&type=script&lang=js"
import style0 from "./Compo.vue?vue&type=style&index=0&id=2c34c346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c34c346",
  null
  
)

export default component.exports